import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subMsg, setSubMsg] = useState('');

  const handleSubscribe = () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) { setSubMsg('Please enter a valid email.'); return; }
    setSubMsg('Thank you for subscribing!');
    setEmail('');
    setTimeout(() => setSubMsg(''), 4000);
  };

  return (
    <footer className="main-footer">
      <div className="footer-widgets">
        <div className="auto-container">
          <div className="row">

            {/* Col 1 — Brand */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-12 footer-col">
              <div className="footer-widget">
                <div className="footer-logo">
                  <Link to="/"><img src="/images/logo.png" alt="Manchester Villa Hotel" /></Link>
                </div>
                <p className="footer-about-text">
                  Manchester Villa Hotel — Plot 34, Area T, behind Apams Casket off PH Road, Owerri, Imo State. A premier destination for comfort, class and culture in the South-East.
                </p>
                <div className="footer-subscribe">
                  <h5 className="widget-title">Stay Updated</h5>
                  <div className="subscribe-row">
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" />
                    <button type="button" onClick={handleSubscribe}><i className="fas fa-paper-plane"></i></button>
                  </div>
                  {subMsg && <p className="sub-msg">{subMsg}</p>}
                </div>
                <div className="footer-social">
                  <h5 className="widget-title">Follow Us</h5>
                  <ul className="social-list">
                    <li><a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a></li>
                    <li><a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a></li>
                    <li><a href="#" aria-label="Twitter"><i className="fab fa-x-twitter"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Col 2 — Room Rates */}
            <div className="col-xl-2 col-lg-2 col-md-6 col-6 footer-col">
              <div className="footer-widget">
                <h4 className="widget-title">Room Rates</h4>
                <ul className="footer-links">
                  <li><Link to="/rooms">🇨🇳 China — ₦30,000/night</Link></li>
                  <li><Link to="/rooms">🇨🇦 Canada — ₦35,000/night</Link></li>
                  <li><Link to="/rooms">🇬🇧 UK — ₦40,000/night</Link></li>
                  <li><Link to="/rooms">🇺🇸 USA — ₦70,000/night</Link></li>
                </ul>
              </div>
            </div>

            {/* Col 3 — Quick Links */}
            <div className="col-xl-2 col-lg-2 col-md-6 col-6 footer-col">
              <div className="footer-widget">
                <h4 className="widget-title">Quick Links</h4>
                <ul className="footer-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/rooms">Rooms</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/pricing">Restaurant</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>

            {/* Col 4 — Contact */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-12 footer-col">
              <div className="footer-widget">
                <h4 className="widget-title">Find Us</h4>
                <ul className="footer-contact-list">
                  <li>
                    <span className="fc-icon"><i className="fas fa-location-dot"></i></span>
                    <div>
                      <strong>Address</strong>
                      <span>Plot 34, Area T, behind Apams Casket, off PH Road, Owerri, Imo State, Nigeria</span>
                    </div>
                  </li>
                  <li>
                    <span className="fc-icon"><i className="fas fa-phone"></i></span>
                    <div>
                      <strong>Reservations</strong>
                      <a href="tel:+2348000000000">+234 (800) 000-0000</a>
                    </div>
                  </li>
                  <li>
                    <span className="fc-icon"><i className="fas fa-envelope"></i></span>
                    <div>
                      <strong>Email</strong>
                      <a href="mailto:info@manchestervilla.com">info@manchestervilla.com</a>
                    </div>
                  </li>
                  <li>
                    <span className="fc-icon"><i className="fas fa-clock"></i></span>
                    <div>
                      <strong>Reception</strong>
                      <span>Open 24 Hours, 7 Days a Week</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="auto-container">
          <div className="footer-bottom-inner">
            <p className="copyright">© {new Date().getFullYear()} <span>Manchester Villa Hotel</span>. All Rights Reserved. Owerri, Imo State.</p>
            <ul className="footer-bottom-links">
              <li><Link to="/">Privacy Policy</Link></li>
              <li><Link to="/">Terms</Link></li>
              <li><Link to="/contact">Support</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
